module.exports = __webpack_public_path__ + "static/flags/SC-62b32cb7867a4eba3e742ad8c208bfb2.gif";